import { render } from "./HR_Position_Dialog.vue?vue&type=template&id=0678cd7f&scoped=true&ts=true"
import script from "./HR_Position_Dialog.vue?vue&type=script&lang=ts"
export * from "./HR_Position_Dialog.vue?vue&type=script&lang=ts"

import "./HR_Position_Dialog.vue?vue&type=style&index=0&id=0678cd7f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0678cd7f"]])

export default __exports__